import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import PersonalPanel from './PersonalPanel';
import {BaseCard} from '../../../components/wizard';
import { extendedstyles } from '../../appstyles';

const extrastyles = (theme:Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    // overflow: 'scroll',
    justifyContent: 'space-between'
  },
  panel: {
    flex: '1 1 auto'
  },
});
const styles = extendedstyles(extrastyles);

class PersonalCard extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.props.deb.log("PersonalCard");
    this.state = {
      next: true,
      idtype: null,
      idfrom: null,
      fwopen: false
    };
  }

  render = () => {
    const { classes, theme, ...extraProps  } = this.props;
    const {record,data,extras,setItem} = this.props;
    const {photo,idcard} = data.start;
    return (
      <BaseCard
        cardid={'PERSONAL'}
        cardname={'Personal'}
        cardtitle={'Personal Information'}
        instruction={'Provide basic information about customer'}
        step={1}
        buttons={['START','CANCEL','PREV','NEXT','GUIDE']}
        {...extraProps}
      >
        <PersonalPanel 
          data={extraProps.data}
          record={record} 
          extras={extras}
          photo={photo} 
          idcard={idcard}
          setItem={setItem}
          />
      </BaseCard>
    );
  }
}

PersonalCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PersonalCard);
